const userManager = {
  getCookieValue(cookieName) {
    const name = cookieName + "="
    const decodedCookie = decodeURIComponent(document.cookie)
    const cookieArray = decodedCookie.split(";")
    for (let cookie of cookieArray) {
      const trimmedCookie = cookie.trim()
      if (trimmedCookie.startsWith(name)) {
        return trimmedCookie.substring(name.length)
      }
    }
    return null
  },

  hasRole(roleName) {
    const rolesCookie = this.getCookieValue("neyeuser")
    if (rolesCookie) {
      const rolesArray = rolesCookie.split(",").map((role) => role.trim())
      return rolesArray.includes(roleName)
    }
    return false
  },

  isClubNeyeLoggedIn() {
    return this.hasRole("clubmember")
  },

  isAuthenticated() {
    return this.hasRole("anonymous")
  },

  isClerk() {
    return this.hasRole("clerk")
  },

  isEmployee() {
    return this.hasRole("employee")
  },

  canSearchCustomer() {
    return this.hasRole("customersearch")
  },

  isClubNeyeAdmin() {
    return this.hasRole("shop")
  },

  isPickupInStoreAdmin() {
    return this.hasRole("pickup")
  },
}

export default userManager
